import { createAction, props } from '@ngrx/store';
import { IProducts } from '../models/products.model';

export const loadCurrentProductsForSomeoneElse = createAction(
  '[CurrentProductsForSomeoneElse] Load CurrentProductsForSomeoneElse',
  props<{ request: string }>()
);

export const loadCurrentProductsForSomeoneElseSuccess = createAction(
  '[CurrentProductsForSomeoneElse] Load CurrentProductsForSomeoneElse Success',
  props<{ response: IProducts[] }>()
);

export const loadCurrentProductsForSomeoneElseFailure = createAction(
  '[CurrentProductsForSomeoneElse] Load CurrentProductsForSomeoneElse Failure',
  props<{ error: Error | any }>()
);
